import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useOrganizationStore } from "@/shared/store/organization.store";

interface MbosGuardProps {
	children: ReactNode;
}

export function MbosGuard({ children }: MbosGuardProps) {
	const isMbos = useOrganizationStore((s) =>
		s.organizations.some((org) => org.name === "Mbos" && org.parentId === null)
	);

	if (!isMbos) {
		return <Navigate to="/dashboard" replace />;
	}

	return <>{children}</>;
}
